module.exports = __webpack_public_path__ + "img/jetvoice2.9521f2fd.png";